import { Component } from "@angular/core";
import { StatsService } from "@/_services/stats.service";
import { LOCAL_STORAGE_KEYS } from "@/_models/filters/local-storage-keys";
import { StatsPromotionResult } from "@/_models/stats-promotion.interface";
import { PerformanceStatsLoader } from "@/components/statistics/performance-tab/performance-tab.component";

@Component({
    selector: "app-performance-promotion",
    templateUrl: "./performance-promotion.component.html",
})
export class PerformancePromotionComponent {
    storageKey = LOCAL_STORAGE_KEYS.PROMOTION_FILTERS;
    loadStats: PerformanceStatsLoader<StatsPromotionResult> = (filters) =>
        this.statsService.getPromotionStats(filters);

    constructor(private statsService: StatsService) {}
}
